// Reserva de citas desde el minisitio: va por la función create_public_appointment (supabase/migrations/20261009c_public_appointments_function.sql), que valida todo en la base.
// El navegador ya no escribe en la tabla de citas: no escoge el negocio, el estado, el origen ni el anticipo.
const ERRORS = {
  negocio_no_disponible: 'Este negocio no está recibiendo reservas por la página en este momento.',
  nombre_invalido: 'Revisa tu nombre.',
  telefono_invalido: 'Revisa tu número de celular (10 dígitos).',
  fecha_invalida: 'Elige una fecha válida.',
  hora_invalida: 'Elige una hora válida.',
  servicio_invalido: 'Alguno de los servicios ya no está disponible. Vuelve a elegirlos.',
  profesional_invalido: 'Ese profesional ya no está disponible. Elige otro.',
  horario_ocupado: 'Ese horario ya no está disponible con ese profesional. Elige otra hora u otro profesional.',
  demasiadas_citas: 'Ya tienes varias reservas con este número. Escríbenos por WhatsApp y te ayudamos.',
  servicio_ocupado: 'Estamos recibiendo muchas reservas en este momento. Intenta de nuevo en unos minutos.'
};

export function publicBookingError(error) {
  const text = `${error?.message || ''} ${error?.details || ''}`;
  const known = Object.keys(ERRORS).find((k) => text.includes(k));
  return known ? ERRORS[known] : 'Hubo un error al procesar tu reserva. Por favor intenta de nuevo.';
}

const functionMissing = (error) => error?.code === 'PGRST202' || error?.code === '42883';

// Devuelve la cita guardada tal como quedó en la base (con el servicio, el teléfono y el profesional normalizados).
// Mientras la migración 20261009c no esté en la base, usa el INSERT de antes para no dejar el minisitio sin reservas durante el despliegue:
// después de 20261009d ese camino ya no existe (y la función sí).
export async function bookPublicAppointment(client, { slug, name, phone, serviceIds, staff, date, time, legacyRow }) {
  const { data, error } = await client.rpc('create_public_appointment', {
    p_slug: slug, p_name: name, p_phone: phone, p_service_ids: (serviceIds || []).map(String), p_staff: staff || null, p_date: date, p_time: time
  });
  if (!error && data) return data;
  if (error && functionMissing(error) && legacyRow) {
    const { error: insertError } = await client.from('appointments').insert([legacyRow]);
    if (insertError) throw insertError;
    return legacyRow;
  }
  throw error || new Error('sin_respuesta');
}
